<template>
    <div class="creation-modal">
        <div class="row">
            <form
                action=""
                class="card col-md-12"
                @submit.prevent=""
            >
                <section class="mb-5">
                    <h4 class="bolder mb-4">
                        Add Documents to the envelope
                    </h4>
                    <div class="form-group">
                        <profile-uploader
                            class=" mr-5"
                            :drag="true"
                            action="/filesystem"
                            tip=""
                            width="200px"
                            @loaded="updateProfile"
                        >
                            <template v-slot:placeholder>
                                <div class="d-flex justify-content-center flex-column align-items-center dealer-upload">
                                    <div class="mb-4">
                                        <img src="./new_contact.svg" alt="new doc" style="height:80px">
                                    </div> 
                                    <div v-if="formData.files">
                                        {{ formData.files.name }}
                                    </div>
                                    <button class="btn btn-primary upload-button mb-2">
                                        UPLOAD
                                    </button>
                                    <button class="btn btn-dealer upload-button mb-2" @click.stop.prevent="''">
                                        Use a template
                                    </button>
                                    <button class="btn btn-dealer upload-button">
                                        Get from the cloud
                                    </button>
                                </div>
                            </template>
                        </profile-uploader>
                        <input
                            v-validate="'required'"
                            :value="fileName"
                            type="hidden"
                            data-vv-as="Document"
                            class="form-control"
                            :name="`document`"
                        >
                        <span class="text-danger">{{ errors.first("document") }}</span>
                    </div>
                </section>

                <section class="row w-100 mb-5">
                    <div class="col-md-12 mb-3">
                        <h4 class="bolder">
                            Add Recipients to the envelope
                        </h4>
                    </div>
                    <div class="col-md-12 d-flex justify-content-between align-items-center">
                        <div>
                            <p>As the sender, you automatically receve a copy of the completed envelope.</p>
                            <p>Import a bulk list. Send compies of this envelope to many peaple at once.</p>
                        </div>
                        <div class="d-flex">
                            <button class="btn btn-default-dealer mr-4">
                                Add from contacts
                            </button>
                            <button class="btn btn-default-dealer">
                                <div class="fa fa-sort-amount-down-alt" />
                                Signing order
                            </button>
                        </div>
                    </div>
                    <div v-if="creationMode" class="form-group col-md-12">
                        <draggable
                            v-model="formData.recipients"
                            handle=".handle"
                            @start="drag = true"
                            @end="drag = false"
                        >
                            <transition-group type="transition" :name="!drag ? 'fade' : null">
                                <div v-for="(recipient, index) in formData.recipients" :key="index" class="card recipient-card w-50">
                                    <button v-if="canDelete" class="btn btn-default recipient-card__delete" @click="removeRecipient(index)">
                                        <i class="fa fa-times" />
                                    </button>
                                    <div class="d-flex">
                                        <div class="d-flex align-items-center mr-2">
                                            <i class="fas fa-grip-vertical handle" />
                                        </div>
                                        <div class="w-50">
                                            <div class="control">
                                                <label for="middleName"> Email</label>
                                                <input
                                                    v-model="recipient.email"
                                                    v-validate="'required'"
                                                    type="text"
                                                    data-vv-as="email"
                                                    class="form-control"
                                                    placeholder="Add show title"
                                                    :name="`${index}-email`"
                                                >
                                                <span class="text-danger">{{ errors.first(`${index}-email`) }}</span>
                                            </div>
                                            <div class="control mt-2">
                                                <label for="middleName"> Name</label>
                                                <input
                                                    v-model.lazy="recipient.name"
                                                    v-validate="'required'"
                                                    data-vv-as="name"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Add show title"
                                                    :name="`${index}-name`"
                                                >
                                                <span class="text-danger">{{ errors.first(`${index}-name`) }}</span>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-end w-50 recipient-card__actions">
                                            <dropdown :is-icon="false" class="bulk-actions">
                                                <button
                                                    id="bulk-actions"
                                                    slot="btn"
                                                    class="btn dropdown-toggle btn-default-dealer"
                                                    type="button"
                                                >
                                                    <div class="fa fa-edit" />
                                                    Needs to sign
                                                </button>
                                                <div slot="body">
                                                    <a
                                                        class="dropdown-item"
                                                        href="#"
                                                        @click.prevent="''"
                                                    >
                                                        Action 1
                                                    </a>
                                                </div>
                                            </dropdown>
                                            <dropdown :is-icon="false" class="bulk-actions">
                                                <button
                                                    id="bulk-actions"
                                                    slot="btn"
                                                    class="btn dropdown-toggle btn-default-dealer"
                                                    type="button"
                                                >
                                                    More
                                                </button>
                                                <div slot="body">
                                                    <a
                                                        class="dropdown-item"
                                                        href="#"
                                                        @click.prevent="''"
                                                    >
                                                        Action 1
                                                    </a>
                                                </div>
                                            </dropdown>
                                        </div>
                                    </div>
                                </div>
                            </transition-group>
                        </draggable>

                        <button class="btn btn-dealer" @click="addRecipient">
                            Add Recipient
                        </button>
                    </div>
                </section>

                <section class="row w-100 bg-gray py-5">
                    <div class="col-md-6">
                        <div class="section-header">
                            <h5 class="bolder">
                                Message to All Recipients
                            </h5>
                            <div class="control">
                                <label for="custom-email">
                                    <input
                                        id="custom-email"
                                        v-model="formData.options.custom_email"
                                        type="checkbox"
                                        name="custom-email"
                                    >
                                    Custom email and language for each recipient
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="d-flex">
                                <div class="w-100">
                                    <div class="control">
                                        <label for="middleName"> Email Subject</label>
                                        <input
                                            v-model.lazy="formData.subject"
                                            v-validate="'required'"
                                            type="text"
                                            class="form-control"
                                            placeholder="Please DocuSign"
                                            :name="`custom-subject`"
                                        >
                                        <span class="text-danger">{{ errors.first("custom-subject") }}</span>
                                    </div>
                                    <div class="control mt-2">
                                        <label for="middleName"> Email Message </label>
                                        <textarea
                                            v-model.lazy="formData.message"
                                            v-validate="'required'"
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter message"
                                            name="custom-message"
                                        />
                                        <span class="text-danger">{{ errors.first("custom-message") }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-if="formData.options.custom_email">
                            <div class="mb-5">
                                <div class="d-flex">
                                    <div class="w-100">
                                        <div class="control">
                                            <label for="middleName"> Select a recipient</label>
                                            <select
                                                v-model="selectedSender"
                                                v-validate="'required'"
                                                type="text"
                                                class="form-control"
                                                placeholder="Please DocuSign"
                                                data-vv-as="Email Subject"
                                                :name="`custom-user`"
                                            >
                                                <option
                                                    v-for="(recipient) in formData.recipients.filter(item => item.name)" 
                                                    :key="recipient.index"
                                                    :value="recipient"
                                                >
                                                    {{  recipient.name || recipient.email }} {{ `(${recipient.email })` }}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{ errors.first(`custom-user`) }}</span>
                                        </div>
                                        <div v-if="selectedSender" class="control">
                                            <label for="middleName"> Email Subject</label>
                                            <input
                                                v-model.lazy="selectedSender.email_subject"
                                                v-validate="'required'"
                                                type="text"
                                                class="form-control"
                                                placeholder="Please DocuSign"
                                                data-vv-as="Email Subject"
                                                :name="`custom-email`"
                                            >
                                            <span class="text-danger">{{ errors.first(`custom-name`) }}</span>
                                        </div>
                                        <div v-if="selectedSender" class="control mt-2">
                                            <label for="middleName"> Email Message </label>
                                            <textarea
                                                v-model.lazy="selectedSender.email_message"
                                                v-validate="'required'"
                                                data-vv-as="Email Message"
                                                type="text"
                                                class="form-control"
                                                placeholder="Enter message"
                                                :name="`custom-name`"
                                            />
                                            <span class="text-danger">{{ errors.first(`custom-name`) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="section-header">
                            <h5 class="bolder">
                                Advanced Options | <span class="small "> Edit </span>
                            </h5>
                            <ul>
                                <li v-for="option in formData.options.advanced" :key="option.name">
                                    {{ option.label }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            </form>

            <div v-if="creationMode" class="col-md-12 text-right">
                <button class="btn btn-primary" :disabled="isLoading" @click.prevent="save">
                    <i class="fa mr-2" :class="[isLoading ? 'fa-circle-notch fa-spin' : 'fa-paper-plane']" />
                    Send
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ProfileUploader from "@c/uploaders/profile-uploader"
import draggable from "vuedraggable"
import { mapState } from "vuex";
import uuid from "uuid/v4";

export default {
    name: "ContractsForm",
    components: {
        ProfileUploader,
        draggable
    },
    props: {
        recordData: {
            type: Object,
            default() {
                return {}
            }
        },
        isFetching: {
            type: Boolean,
            default: false
        },
        creationMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            formData: {},
            endpoint: "filesystem",
            isLoading: false,
            drag: false,
            selectedSender: null
        }
    },
    computed: {
        ...mapState({
            user: state => state.User.data,
            companies: state => state.Company.list,
            company: state => state.Company.data
        }),
        createButtonText() {
            return this.formData.id ? "Save Changes" : "Create"
        },

        fileName() {
            return this.formData.files ? this.formData.files.name : "";
        },

        canDelete() {
            return this.formData.recipients.length > 1;
        }
    },
    watch: {
        recordData: {
            handler(data) {
                if (data.id) {
                    data.is_simulcast = !!+data.is_simulcast;
                    this.formData = data;
                } else {
                    this.clearForm();
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        onSuccess(data) {
            this.$emit("saved", data);
            this.clearForm();
        },

        clearForm() {
            this.formData = {
                subject: "",
                message: "",
                recipients: [{
                    index: uuid(),
                    email: "",
                    name: ""
                }],
                options: {
                    custom_email: false,
                    advanced: [
                        {
                            name: "signin_on_paper",
                            label: "Recipients can sign in on paper"
                        },
                        {
                            name: "chancge_responsibility",
                            label: "Recipients can change sign in responsibility"
                        },
                        {
                            name: "expire_in_120",
                            label: "Incompletes envelopes expires 120 days after send date"
                        },
                        {
                            name: "warn_before",
                            label: "recipients are warned 0 days before request expires"
                        },
                        {
                            name: "comments_enabled",
                            label: "Comments are enabled"
                        },
                        {
                            name: "edvanced_send",
                            label: "Senders can use either quick send or advanced edit"
                        }
                    ]
                }
            }
        },

        addRecipient() {
            this.formData.recipients.push({
                index: uuid(),
                email: "",
                name: ""
            })
        },

        removeRecipient(index) {
            this.formData.recipients.splice(index, 1)
        },

        prepareForm(isDataForm) {
            const formData = { ...this.formData };
            if (isDataForm) {
                const DataForm = new FormData();
                DataForm.append("file", formData.files.raw)
                DataForm.append("subject", formData.subject)
                DataForm.append("message", formData.message)
                formData.recipients.forEach((recipient, index) => {
                    DataForm.append(`recipients[${index}]`, JSON.stringify(recipient))
                    // DataForm.append(`recipients[${index}][name]`, recipient.name)
                })
                return DataForm
            } else {
                formData.files = formData.files && formData.files.length ? formData.files.map(this.formatFileSystem) : [];
                return formData;
            }
        },

        async save() {
            const isValid = await this.$validator.validateAll()
            let method = "POST";
            let url = this.endpoint;

            if (!isValid) {
                return;
            }

            const formData = this.prepareForm(true);

            if (formData.id) {
                method = "PUT"
                url += `/${formData.id}`
            }

            this.isLoading = true;

            axios({
                url: url,
                data: formData,
                method: method
            }).then(({ data }) => {
                this.onSuccess(data);
            })
                .catch((error) => {
                    this.$notify({
                        title: "Error",
                        text: error.response ? error.response.data.errors.message : "Error",
                        type: "error"
                    });
                    return false;
                })
                .finally((result) => {
                    this.isLoading = false;
                    return result;
                })
        },

        updateProfile(files) {
            this.$set(this.formData, "files", files);
        }
    }
}
</script>

<style lang="scss">
.creation-modal {
   .modal-header {
    border-bottom: none;

    .btn-close {
        color: var(--execlist-color-gray4);
        cursor: pointer;
    }
   }

    .el-upload-dragger {
        width: 250px !important;
        height: 270px !important;
    }
}

.upload-button {
    font-size: 15px;
    width: 100%;
    border-radius: 0 0 0 0;
    margin: 2px 15px !important;
}

.recipient-card {
    border: 1px solid #ccc !important;
    position: relative;
    padding-top: 40px !important;

    &__delete {
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 0 0 0 0;
    }

    &__actions {
        .btn {
            height: 38px !important;
            background: transparent
        }
    }
}


.handle {
    cursor: move;
}
</style>
